import React from "react";
import { Helmet } from "react-helmet";
import filterItemsStore from "../../Store/filterItems";

const withTitle: (WrappedComponent: any, title?: string) => any = (
    WrappedComponent,
    title
) => {
    return (props: any) => {
        const baseTitle: string = "Metso IB Portal";
        const { activeDetail, match } = props;

        if (!match) {
            return <WrappedComponent {...props} />;
        }

        const { params, url } = match;

        let newTitle: string;

        if (title) {
            newTitle = `${title}`;
        } else {
            if (url === "/products") {
                newTitle = `Products`;
            } else if (url === "/customers") {
                newTitle = `Customers`;
            } else if (url === "/sites") {
                newTitle = `Sites`;
            } else if (url === "/search") {
                newTitle = `Search`;
            }
        }

        return (
            <>
                <Helmet>
                    <title>
                        {newTitle ? `${newTitle} - ${baseTitle}` : baseTitle}
                    </title>
                </Helmet>
                <WrappedComponent {...props} />
            </>
        );
    };
};

export default withTitle;
